export default "__VITE_ASSET__C8iN6lbi__"